import React, { Component } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import Frontend from './website/frontend/frontend'
 
class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/frontend" />} />
        <Route component={Frontend}/>
      </Switch>
    )
  }
}

export default App
